module.exports = __webpack_public_path__ + "img/cimg05.5890cea2.png";